export default String.raw`
.history-popup {
    min-width: unset;
    
    .dialog {
        &__header-title {
            @include h3-headline;
        }

        &__content {
            padding: 8px 16px 16px 16px;
        }
    }

    &__table {
        .table {
            &__header {
                .table__cell {
                    @include body-2-medium;
                }
            }
            
            &__body {
                @include body-2-regular;
            }

            &__cell {
                padding: 10px 8px;
            }
        }
    }
}
`